export default "__VITE_ASSET__cee5d7f5__"